import { render, staticRenderFns } from "./two-factor-auth.vue?vue&type=template&id=5a00bdba&scoped=true&"
import script from "./two-factor-auth.vue?vue&type=script&lang=tsx&"
export * from "./two-factor-auth.vue?vue&type=script&lang=tsx&"
import style0 from "./two-factor-auth.vue?vue&type=style&index=0&id=5a00bdba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a00bdba",
  null
  
)

export default component.exports